import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'

import bookkeepers from 'modules/bookkeepers/store/collections/bookkeepers'

export const useBookkeepersProfessionals = () => {
  const { loading } = useAsyncData(() => {
    if (hasFeature('factorial_professionals')) {
      return bookkeepers.fetch()
    }
    return Promise.resolve()
  }, [])

  return {
    loading,
    bookkeepers,
  }
}
